import { clsx } from "clsx"
import { getInitials } from "@src/utils/image"

export type PlaceholderImageProps = {
  name: string
  className?: string
}

export const PlaceholderImage = ({
  name,
  className,
}: PlaceholderImageProps) => {
  const initials = getInitials(name)
  const accessibilityProps = name
    ? { role: "img", "aria-label": name }
    : { "aria-hidden": true }

  return (
    <div
      {...accessibilityProps}
      className={clsx([
        "flex items-center justify-center bg-blue-light font-bold text-blue-dark",
        className,
      ])}
    >
      {initials || ""}
    </div>
  )
}
